import Axios, { CancelTokenSource } from "axios";

import { API } from "utils/api-config";

import { defaultErrorResponse } from "api/defaults";

import { IInvoiceAdditionalHeaderInformation } from "store/environments/tenants/invoices/invoice-additional-header-information/invoice-additional-header-information-types";

export const loadInvoiceAdditionalHeaderInformationField = async (
    envMoniker: string,
    tenantId: string,
    fieldName: string,
    cancelTokenSource?: CancelTokenSource
): Promise<[IInvoiceAdditionalHeaderInformation | null, number]> => {
    if (!envMoniker || !tenantId) {
        return defaultErrorResponse;
    }
    const response = await API.get(
        `environments/${envMoniker}/tenants/${tenantId}/invoices/additional-headers/fields/${fieldName}`,
        { cancelToken: cancelTokenSource?.token }
    );

    if (!cancelTokenSource?.token.reason) {
        if (!response) {
            return defaultErrorResponse;
        }

        return [response.data, response.status];
    } else {
        throw new Axios.Cancel();
    }
};

export const updateInvoiceAdditionalHeaderInformationField = async (
    envMoniker: string,
    tenantId: string,
    invoiceAdditionalHeaderInformationField: IInvoiceAdditionalHeaderInformation
): Promise<[string | null, number]> => {
    if (!envMoniker || !tenantId) {
        return defaultErrorResponse;
    }
    const fieldName = invoiceAdditionalHeaderInformationField.fieldName;

    const response = await API.put(
        `environments/${envMoniker}/tenants/${tenantId}/invoices/additional-headers/fields/${fieldName}`,
        invoiceAdditionalHeaderInformationField
    );

    return [null, response.status];
};
